<div *ngIf="tutor" class="container-fluid">

    <div class="row mb-2">

        <!-- NIF/NIE -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">DNI/NIE</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.dni" readonly="true"/>
            </div>
        </div>

        <!-- Correo electrónico -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Correo electrónico</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.mail" readonly="true"/>
            </div>
        </div>

    </div>

    <div class="row mb-2">

        <!-- Nombre -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Nombre</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.name" readonly="true"/>
            </div>
        </div>

        <!-- Apellidos -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Apellidos</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.surname" readonly="true"/>
            </div>
        </div>

    </div>

    <div class="row mb-2">

        <!-- Teléfono 1 -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Teléfono 1</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone1" readonly="true"/>
            </div>
        </div>

        <!-- Teléfono 2 -->
        <div class="col-12 col-md-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Teléfono 2</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone2" readonly="true"/>
            </div>
        </div>

    </div>

</div>
